import { Button } from "@mui/material";
import React from "react";

const BasicButton = ({ text, onClick, sx, className, icon, iconPosition = "left", ...rest }) => {
  return (
    <Button
      onClick={onClick}
      className={`capitalize ${className}`}
      sx={sx}
      size="small"
      variant="contained"
      {...rest}
    >
      {icon && iconPosition === "left" && (
        <span style={{ marginRight: 8, display: "flex" }}>{icon}</span>
      )}
      {text}
      {icon && iconPosition === "right" && (
        <span style={{ marginLeft: 8, display: "flex" }}>{icon}</span>
      )}
    </Button>
  );
};

export default BasicButton;
